import AppIcon from "@/common/components/Icons/AppIcon";
import { useOnboardingContextOptional } from "@/common/contexts/onboarding";
import { ApiEnumName } from "@/common/services/enum";

import AppIconButton, { AppIconButtonProps } from "../../Button/AppIconButton";
import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";

interface Props {
  iconButtonProps?: AppIconButtonProps;
}

export function OnboardingHelpIconButton({ iconButtonProps }: Props) {
  const onboardingContext = useOnboardingContextOptional();

  if (!onboardingContext?.isEnabled || !onboardingContext?.onboarding) {
    return null;
  }

  return (
    <>
      <AppIconButton
        color='text'
        tooltipProps={{
          title: (
            <>
              Onboarding:{" "}
              <InlineApiEnumValue
                type={ApiEnumName.OnboardingStatus}
                value={onboardingContext.onboarding.status}
              />
            </>
          ),
          isDefaultEnterDelays: true,
        }}
        onClick={() => {
          onboardingContext.popper.toggle();
        }}
        {...iconButtonProps}
      >
        <AppIcon of='help' />
      </AppIconButton>
    </>
  );
}
